'use client'

import { useLocale } from 'next-intl'

import { useSearchFilterStore } from '@/entities/map'
import {
  MobileDiscountBadge,
  MobileOverview,
  MobilePriceDetail,
  RoomThumbnail,
  SuperHostBadge,
  TRoomPreview,
} from '@/entities/room'
import { Link } from '@/shared/i18n'
import { cn, getURLWithParams } from '@/shared/lib'

type Props = {
  room: TRoomPreview
}

export const MobileRoomItem = ({ room }: Props) => {
  const locale = useLocale()
  const isEnglish = locale === 'en'

  const startDate = useSearchFilterStore(state => state.filters.startDate)
  const endDate = useSearchFilterStore(state => state.filters.endDate)

  return (
    <Link
      className="flex grow cursor-pointer flex-col py-5 group-first:pt-0 group-last:pb-0"
      href={getURLWithParams(`/guest/room/${room.rid}`, {
        startDate,
        endDate,
      })}
    >
      <div className="flex gap-4">
        <div className="relative shrink-0 overflow-hidden rounded-sm">
          {room.isSuperHost && (
            <SuperHostBadge
              width={isEnglish ? 85 : 52}
              height={18}
              className={cn('absolute top-1 left-1 z-1')}
            />
          )}
          <RoomThumbnail
            src={room.picMain}
            alt={room.roomName}
            rounded
            size={100}
            ratio="4:3"
            unoptimized
          />
        </div>

        <div>
          <MobileOverview
            province={room.province}
            town={room.town}
            propertyType={room.propertyType}
            roomName={room.roomName}
            roomCnt={room.roomCnt}
            bathroomCnt={room.bathroomCnt}
            cookroomCnt={room.cookroomCnt}
            sittingroomCnt={room.sittingroomCnt}
            usingFee={room.usingFee}
            mgmtFee={room.mgmtFee}
          />
          <MobilePriceDetail usingFee={room.usingFee} mgmtFee={room.mgmtFee} />
        </div>
      </div>
      <MobileDiscountBadge
        percent={room.longtermDiscountPer}
        amount={room.earlyDiscountAmount}
        className="mt-2"
      />
    </Link>
  )
}
